export const LOCKED_ICON = 'LOCKED_ICON';
export const LOCKED_SUBTITLE = 'Login to your account';

export const EXPERIMENT_ORDER_VARIANTS = {
  VARIANT_A: 'postorder_default_A',
  VARIANT_B: 'postorder_default_B',
};
